module.exports = __webpack_public_path__ + "assets/GEFOOTERWHITE.8c18b2d4.png";